import React, { useState } from 'react';
import ComCalendarPart from './partials/ComCalendarPart';
import ComBookingPart from './partials/ComBookingPart';
import ComSlotsPart from "./partials/ComSlotsPart";

const ComCalendarView = () => {
    const [view, setView] = useState('calendar'); // calendar, booking, slots

    return (
        <>
            <div className='calendar-tabs'>
                <button onClick={() =>setView('calendar')} className={` ${view === 'calendar' ? 'calendar-tabs-item-active' : ''} calendar-tabs-item`}>Mon calendrier</button>
                <button onClick={() => setView('booking')} className={` ${view === 'booking' ? 'calendar-tabs-item-active' : ''} calendar-tabs-item`}>Réserver une visite</button>
                <button onClick={() => setView('slots')} className={` ${view === 'slots' ? 'calendar-tabs-item-active' : ''} calendar-tabs-item`}>Créneaux de visites</button>
            </div>


            {view === 'calendar' ? (
                <ComCalendarPart />
            ) : view === 'booking' ? (
                <section className='mbe-section mbe-bookingSlot-container'>
                    <div className="mbe-bookingSlot-container-headline">
                        <h3 className="color-black">Réserver un créneau de visite pour le projet d’un client</h3>
                        <p className="text-primary">
                            Sélectionner le numéro d’un projet ainsi que le nom d’un client pour sélectionner un créneau de visite.
                            <br/>
                            Votre demande sera envoyée à l’administrateur qui devra valider votre demande depuis son espace
                        </p>
                    </div>
                    <ComBookingPart />
                </section>
            ) : view === 'slots' ? (
                <section className='mbe-section mbe-bookingSlot-container'>
                    <ComSlotsPart />
                </section>
            ) : null}
        </>
    );
};

export default ComCalendarView;

